import { createApp } from 'vue'
import VueKonva from 'vue-konva'
import Camera from 'simple-vue-camera'
import App from './App.vue'

const app = createApp(App)
app.use(VueKonva)
app.component('camera', Camera)
app.mount('#app')
